import React from 'react'
import "./CardContainerStyles.scss"
const CardContainer = ({ children, customCssClass = "" }) => {
    return (
        <div className={`container-card-body rounded bg-white overflow-hidden shadow-lg ${customCssClass}`}>{children}</div>
    )
}

export default CardContainer